/* istanbul ignore next */
export function getElementOffsetTop(id: string): number {
  const elem: HTMLElement | null = document.querySelector(id);

  return elem?.getBoundingClientRect().top || 0;
}
